
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import { isBrowser } from 'react-device-detect';
import PN from 'persian-number'
import { trackPromise } from 'react-promise-tracker';
import { Helmet } from "react-helmet";
import * as ReactDOM from 'react-router-dom';

const MotorSuggestionIndex = () => {

    //#region Const 
    const toaster = rsuite.useToaster();
    const scrollToRef = React.useRef(null);
    const [List, setList] = React.useState([]);
    const [ProductList, setProductList] = React.useState([]);
    const [PowerNeed, setPowerNeed] = React.useState(0);
    const [background, setbackground] = React.useState("../assets/Images/MotorSuggestionBaner.JPEG");
    const navigate = ReactDOM.useNavigate();

    // const ScrollLink = Scroll.ScrollLink



    const GetList = () => {
        trackPromise(

            fetch(General.ApiRoute() + '/SuggestionProduct/GetForWeb', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'WebIsActive': 1,
                    'IsActive': -1
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    console.dir(result)
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Title: result[i].typeComment,
                            Type: result[i].type,
                            Children: result[i].children


                        })
                    }
                    console.dir(tmp)
                    setList(tmp)
                })
        )
    }

    const SelectPr = (check, id, type) => {

        setProductList([]);
        var temp = [...List];
        var index = temp.findIndex(x => x.Type == type);

        if (index != -1) {
            var innerindex = temp[index].Children.findIndex(x => x.id == id);

            if (innerindex != -1) {
                temp[index].Children[innerindex].checked = check ? 1 : 0;
                setPowerNeed(check ? temp[index].Children[innerindex].power + PowerNeed : PowerNeed - temp[index].Children[innerindex].power)
            }
        }
        setList(temp);
    }

    const SuggestMotor = () => {
        trackPromise(

            fetch(General.ApiRoute() + '/Product/SuggestMotor', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Power': PowerNeed,
                    'Current': -1

                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            // ParentId: result[i].parentId,
                            SaleType: result[i].saleType,
                            LastPrice: result[i].lastPrice,
                            FinalPrice: result[i].finalPrice,
                            Discount: result[i].discount,
                            ParentTitle: result[i].parentTitle,
                            GroupTitle: result[i].groupTitle,
                            BrandTitle: result[i].brandTitle,
                            Comment: result[i].comment,
                            Power: result[i].power,
                            Current: result[i].current,
                            SaleCount: result[i].saleCount * 1,
                            IdentityNo: result[i].identityNo,
                            photoTag: result[i].photoTag,
                            PhotoList: result[i].photos,
                            PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',


                        })
                    }
                    setProductList(tmp)

                    if (scrollToRef.current) {
                        scrollToRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                })
        )
    }


    const ShowProduct = (id, title, Parent, Group) => {
        localStorage.setItem("ProductId", id);
        localStorage.setItem("ByBrand", false);
        localStorage.setItem("BySuggestion", true);
        localStorage.setItem("ByCompare", false);

        var parent = General.toSlug(Parent, { latin: true })
        var group = General.toSlug(Group, { latin: true })
        var product = General.toSlug(title, { latin: true })
        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");

        navigate('/ProductInfo/' + parent + "/" + NewGroup + "/" + Newproduct)

    }

    //#endregion
    React.useEffect(() => {
        GetList();
        document.title = "پیشنهاد موتور برق ";
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                // className={styles.article}
                style={{ backgroundImage: `url(${background})` }}
            >
            </div>
            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}>پیشنهاد موتور برق
                <div className={isBrowser ? "InnerBanner-sub-title" : 'hide'}>Motor Suggestion </div>
            </h1>
            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb>
                    <rsuite.Breadcrumb.Item href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>

                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>پیشنهاد موتور برق</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>
            </h1>
            <rsuite.Panel className="pt-3">



                <rsuite.Row className=" ">
                    <rsuite.Col xs={24} sm={24} md={12} lg={12} className="p-4">
                        <rsuite.Card shaded className="w-100p " direction="row" >

                            <rsuite.Card.Header as="h6" className="FarmAsan-bg p-3 text-truncate Font20 text-center" >انتخاب لوازم


                                <rsuite.Row >
                                    <rsuite.Col xs={24} mdHidden lgHidden xlHidden xxlHidden className="p-2 ">
                                        <rsuite.Tag size="sm" className="w-100p p-3" block><b>توان مورد نیاز </b> {PowerNeed} (وات W)</rsuite.Tag>



                                    </rsuite.Col>
                                    <rsuite.Col xs={24} mdHidden lgHidden xlHidden xxlHidden className="p-2">
                                        <rsuite.Button color="green" className="p-3" disabled={PowerNeed == 0 ? true : false} onClick={() => SuggestMotor()} appearance="primary" block>  پیشنهاد موتور برق مناسب</rsuite.Button>

                                    </rsuite.Col>
                                </rsuite.Row>

                            </rsuite.Card.Header>
                            <rsuite.Card.Body className=" h-90vh-y" >

                                {List.map(pr => (
                                    <>
                                        <rsuite.Divider className="mt-4 pt-4">
                                            <rsuite.Heading className="mb-3" level={6}>{pr.Title}</rsuite.Heading>
                                        </rsuite.Divider>

                                        <rsuite.List>

                                            {pr.Children.map(inner =>




                                                <rsuite.List.Item onClick={(e) => SelectPr(inner.checked == 1 ? 0 : 1, inner.id, pr.Type)} className={inner.checked == 1 ? "bg-light Font14 Cursor pe-2 ps-2" : " Font13 pe-2 Cursor ps-2"} key={inner.id}>
                                                    <rsuite.Row className={isBrowser ? "Font14" : " Font12"}>
                                                        <rsuite.Col className="" xs={24} sm={24} md={12} >
                                                            <rsuite.Checkbox
                                                                // inline
                                                                checked={inner.checked}
                                                                onChange={(e, checked) => SelectPr(checked, inner.id, pr.Type)}
                                                            />
                                                            {inner.title}
                                                        </rsuite.Col>
                                                        <rsuite.Col className="pt-1" xs={24} sm={24} md={12} >
                                                            <div className="text-start">

                                                                میانگین توان مصرفی  <b> {inner.power}  </b> وات (w)
                                                            </div>
                                                        </rsuite.Col>
                                                    </rsuite.Row>

                                                </rsuite.List.Item>

                                            )
                                            }
                                        </rsuite.List>
                                    </>

                                ))}
                            </rsuite.Card.Body>




                        </rsuite.Card>
                    </rsuite.Col>
                    <rsuite.Col xsHidden smHidden md={12} lg={12} className="p-4">
                        <rsuite.Card shaded className="w-100p" direction="row" >

                            <rsuite.Card.Header as="h6" className="FarmAsan-success  p-3 text-truncate Font20 text-center" > لوازم انتخاب شده</rsuite.Card.Header>
                            <rsuite.Card.Body className=" h-90vh-y" >
                                <rsuite.Row >
                                    <rsuite.Col xs={12} className="p-2 ">
                                        <rsuite.Tag size="sm" className="w-100p p-3" block><b>توان مورد نیاز </b> {PowerNeed} (وات W)</rsuite.Tag>



                                    </rsuite.Col>
                                    <rsuite.Col xs={12} className="p-2">
                                        <rsuite.Button color="green" className="p-3" disabled={PowerNeed == 0 ? true : false} onClick={() => SuggestMotor()} appearance="primary" block>  پیشنهاد موتور برق مناسب</rsuite.Button>

                                    </rsuite.Col>
                                </rsuite.Row>
                                {List.map(pr => (
                                    pr.Children.filter(x => x.checked == 1).length > 0 ?
                                        <>
                                            <rsuite.Divider className="mt-4 pt-4">
                                                <rsuite.Heading className="mb-3" level={6}>{pr.Title}</rsuite.Heading>
                                            </rsuite.Divider>

                                            <rsuite.List>
                                                {pr.Children.map(inner =>

                                                    <rsuite.List.Item onClick={(e) => SelectPr(inner.checked == 1 ? 0 : 1, inner.id, pr.Type)} className={inner.checked == 1 ? "Font14 Cursor pe-2 ps-2" : " hide"} key={inner.id}>
                                                        <rsuite.Row >
                                                            <rsuite.Col xs={12}>

                                                                {inner.title}
                                                            </rsuite.Col>
                                                            <rsuite.Col className="pt-1" xs={12}>
                                                                <div className="text-start">

                                                                    میانگین توان مصرفی  <b> {inner.power}  </b> وات (w)
                                                                </div>
                                                            </rsuite.Col>
                                                        </rsuite.Row>

                                                    </rsuite.List.Item>

                                                )
                                                }
                                            </rsuite.List>
                                        </>
                                        :
                                        <></>

                                ))}
                            </rsuite.Card.Body>




                        </rsuite.Card>
                    </rsuite.Col>
                    <rsuite.Col xs={24}>
                        <div className="scroll-target" ref={scrollToRef}>
                            {ProductList.length > 0 ?
                                <rsuite.Grid className={isBrowser ? "pt-3 mb-3" : "pt-3 mb-3 mr-0 ml-0 pr-0 pl-0"} >
                                    <rsuite.Message type="success">
                                        <strong>بهترین انتخاب!</strong>  {ProductList[0].GroupTitle} - {ProductList[0].Title}
                                    </rsuite.Message>
                                    <rsuite.Row className="justify-content-center align-items-center p-4">

                                        <rsuite.Col xs={24} sm={24} md={12} >
                                            <div className="shadow p-3 me-2 ms-2 bg-body rounded w-100p h-40vh">

                                                <rsuite.Image
                                                    src={General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + ProductList[0].PhotoUrl}
                                                    fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                                    alt={ProductList[0].PhotoTag}
                                                    placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '38vh' }} />
                                                    }
                                                    style={{ width: '100%', height: '38vh' }}
                                                    className="border-radius-half"
                                                    zoomed
                                                />


                                            </div>


                                        </rsuite.Col>
                                        <rsuite.Col xs={24} sm={24} md={12} >
                                            <div className="shadow p-3 me-2 ms-2 bg-body rounded w-100p h-40vh">
                                                <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                    <b> {ProductList[0].Title} </b>
                                                </p>
                                                <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                    <b>دسته </b> {ProductList[0].GroupTitle}
                                                </p>
                                                <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                    <b>برند </b> {ProductList[0].BrandTitle}
                                                </p>

                                                <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                    <b>توان واقعی </b> {ProductList[0].Power} (کیلووات KW)
                                                </p>
                                                {/* <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                    <b>جریان </b> {ProductList[0].Current} (آمپر A)
                                                </p> */}

                                                {/* <p className={Comment != "" ? "mb-4 pb-2" : "hide"}>
                                                <Interweave content={ProductList[0].Comment} />
                                            </p> */}


                                                {ProductList[0].SaleType != 3 ?
                                                    <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                        <b>قیمت </b> <span className={ProductList[0].Discount != 0 ? ' Font14  text-decoration-line-through' : "Font14  "} > {PN.sliceNumber(ProductList[0].LastPrice)}</span>  ریال     &nbsp;&nbsp;&nbsp;<rsuite.Badge color="green" className={ProductList[0].Discount != 0 ? "" : "hide"} content={ProductList[0].Discount + '%'}></rsuite.Badge></p>
                                                    :

                                                    <p className="fw-bold text-danger pt-1">قیمت در حال به روزرسانی </p>

                                                }

                                                <p className={ProductList[0].Discount != 0 ? 'Font14 fw-bold text-success mt-4' : "hide"} ><b>قیمت نهایی </b>{PN.sliceNumber(ProductList[0].FinalPrice)} ریال</p>

                                                <rsuite.Row className={isBrowser ? "mt-4" : "mt-2"}>
                                                    <rsuite.Col xs={24} sm={24} md={12} className="p-2" >
                                                        <rsuite.TagGroup >
                                                            {ProductList[0].SaleCount > 0 && ProductList[0].SaleType == 1 ?
                                                                <rsuite.Tag size="sm" className="w-100p p-1"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {ProductList[0].SaleCount}</rsuite.Tag>

                                                                : ProductList[0].SaleCount == 0 && ProductList[0].SaleType == 1 ?
                                                                    <rsuite.Tag size="sm" className="w-100p p-1"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                                    : ProductList[0].SaleType == 2 ?
                                                                        <rsuite.Tag size="sm" className="w-100p p-1"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '30px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                                        : ProductList[0].SaleType == 3 ?
                                                                            <rsuite.Tag size="sm" className="w-100p p-1"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '30px' }} />فروش بسته می باشد</rsuite.Tag>
                                                                            :
                                                                            <></>
                                                            }

                                                        </rsuite.TagGroup>
                                                    </rsuite.Col>
                                                    <rsuite.Col xs={24} sm={24} md={12} className="p-2">

                                                        <rsuite.Button color="green" disabled={(ProductList[0].SaleCount > 0 && ProductList[0].SaleType == 1) || ProductList[0].SaleType == 2 ? false : true} appearance="primary" block>  اضافه به سبد خرید </rsuite.Button>

                                                    </rsuite.Col>
                                                </rsuite.Row>
                                            </div>
                                        </rsuite.Col>
                                    </rsuite.Row>

                                    {ProductList.length > 1 ?
                                        <rsuite.Row >
                                            <rsuite.Divider className="mt-4 pt-4">
                                                <rsuite.Heading className="mb-3" level={6}>دیگر پیشنهادات  </rsuite.Heading>
                                            </rsuite.Divider>
                                            {ProductList.map(group => (
                                                group.row > 1 ?

                                                    <rsuite.Col xs={24} sm={24} md={12} lg={12} className="p-2">

                                                        <rsuite.Card className="w-100p " shaded direction="row" >
                                                            <rsuite.Row>

                                                                <rsuite.Col xs={9} className="m-0 p-0">

                                                                    <rsuite.Image
                                                                        src={group.PhotoUrl}
                                                                        fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                                                        alt={group.PhotoTag}
                                                                        // placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '170px' }} />
                                                                        // }
                                                                        style={{ width: '150px', height: '170px' }}
                                                                        className="border-radius-half Cursor"
                                                                        onClick={() => ShowProduct(group.Id, group.Title, group.ParentTitle, group.GroupTitle)}
                                                                    />
                                                                </rsuite.Col>
                                                                <rsuite.Col xs={15} className="m-0 p-0" >
                                                                    <rsuite.Card.Header as={isBrowser ? "h5" : "h6"} className="Cursor text-truncate" onClick={() => ShowProduct(group.Id, group.Title, group.ParentTitle, group.GroupTitle)}>{group.Title}</rsuite.Card.Header>
                                                                    <rsuite.Card.Body className="Cursor" onClick={() => ShowProduct(group.Id, group.Title, group.ParentTitle, group.GroupTitle)}>
                                                                        <p className={isBrowser ? "Font14" : "Font13"}><b>دسته : </b> {group.GroupTitle}</p>
                                                                        <p className={isBrowser ? "Font14" : "Font13"}><b>برند : </b> {group.BrandTitle}</p>
                                                                        <p className={isBrowser ? "Font14" : "Font13"}><b>توان واقعی  : </b> {group.Power} (کیلووات KW) </p>
                                                                        {/* <p className={isBrowser ? "Font14" : "Font13"}><b>جریان  : </b> {group.Current}  (آمپر A) </p> */}


                                                                        {group.SaleType != 3 ?
                                                                            <p className="Font13 FarmAsan-text"><b>قیمت :  </b> {PN.sliceNumber(group.LastPrice)} ریال</p>
                                                                            :

                                                                            <p className="fw-bold text-danger pt-1">قیمت در حال به روزرسانی </p>

                                                                        }

                                                                    </rsuite.Card.Body>

                                                                </rsuite.Col>
                                                            </rsuite.Row>
                                                            <rsuite.Row >
                                                                <rsuite.Col xs={12} className="p-2">
                                                                    <rsuite.TagGroup>
                                                                        {group.SaleCount > 0 && group.SaleType == 1 ?
                                                                            <rsuite.Tag size="sm" className="w-100p"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {group.SaleCount}</rsuite.Tag>

                                                                            : group.SaleCount == 0 && group.SaleType == 1 ?
                                                                                <rsuite.Tag size="sm" className="w-100p"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                                                : group.SaleType == 2 ?
                                                                                    <rsuite.Tag size="sm" className="w-100p"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '40px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                                                    : group.SaleType == 3 ?
                                                                                        <rsuite.Tag size="sm" className="w-100p"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '40px' }} />  فروش بسته می باشد</rsuite.Tag>
                                                                                        :
                                                                                        <></>
                                                                        }

                                                                    </rsuite.TagGroup>
                                                                </rsuite.Col>
                                                                <rsuite.Col xs={12} className="p-2">
                                                                    <rsuite.Button color="green" disabled={(group.SaleCount > 0 && group.SaleType == 1) || group.SaleType == 2 ? false : true} appearance="primary" block>  اضافه به سبد خرید </rsuite.Button>

                                                                </rsuite.Col>
                                                            </rsuite.Row>

                                                        </rsuite.Card>



                                                    </rsuite.Col>
                                                    :
                                                    <></>
                                            )
                                            )}
                                        </rsuite.Row >
                                        :
                                        <></>
                                    }
                                </rsuite.Grid>


                                :
                                <rsuite.Message type="error">
                                    <strong> عدم موجودی!</strong>  موتور برق مناسب توان مصرفی شما موجود نمی باشد
                                </rsuite.Message>

                            }
                        </div>
                    </rsuite.Col>
                </rsuite.Row>
            </rsuite.Panel>


        </Layout >
    )
}

export default MotorSuggestionIndex;